import { Component, inject } from '@angular/core';
import { UserdataService } from '../../../service/userdata.service';
import { inviteDisabled, serverurl } from '../../../../environments/environment';
import { AiService } from '../../../service/ai.service';
import { MatDialog } from '@angular/material/dialog';
import { SettingsComponent } from '../../user/settings/settings.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'rr-teamheader',
  standalone: false,

  templateUrl: './teamheader.component.html',
  styleUrl: './teamheader.component.scss'
})
export class TeamheaderComponent {
  userservice = inject(UserdataService);
  serverurl = serverurl;
  showLimit: number = 2;
  inviteDisabled = inviteDisabled;
  teammembers: any[] = [
    // { id: 1, prename: 'Matze', lastname: 'Schmitt' },
    // { id: 2, prename: 'Jan', lastname: 'Grönefeld' },
    // { id: 3, prename: '', lastname: '' },
    // { id: 4, prename: '', lastname: '' }
  ];

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.userservice.data.subscribe((data: any) => {
      // this.teammembers = data.licenseMembers.filter((member: any) => member.id !== data.id);
    })
  }



  async openSettings(page: number) {
    let dia = this.dialog.open(SettingsComponent, {
      data: { "page": page },
      autoFocus: false,
    });
    dia.afterClosed().subscribe((result) => {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { 'settings': null, 'page': null },
        queryParamsHandling: 'merge'
      });
    });
  }
}
